<template>
  <div>
    <span>{{ formattedDate }}</span>
  </div>
</template>

<script>
import Common from '../../helper/Common';
export default {
  data() {
    return {
      formattedDate: ''
    };
  },
  mounted() {
    this.formattedDate = `${Common.formatDate(this.data.modifiedOn)} ${Common.formatTime(this.data.createdOn)}`;
  }
};
</script>

<style lang="scss" scoped>
</style>
